import { type Documentish } from "./image_attachments";
import { isPouchError } from "./utils";

export function generateThumbnail(srcUrl: string, maxSize: number): Promise<Blob | null> {
  return new Promise(resolve => {
    const img = new Image();
    img.onload = () => {
      const scale = Math.min(maxSize / img.naturalWidth, maxSize / img.naturalHeight, 1);
      const w = Math.max(1, Math.round(img.naturalWidth * scale));
      const h = Math.max(1, Math.round(img.naturalHeight * scale));
      const canvas = document.createElement("canvas");
      canvas.width = w;
      canvas.height = h;
      const ctx = canvas.getContext("2d");
      if (ctx == null) { resolve(null); return; }
      ctx.drawImage(img, 0, 0, w, h);
      canvas.toBlob(resolve, "image/jpeg", 0.75);
    };
    img.onerror = () => resolve(null);
    img.src = srcUrl;
  });
}

export async function backfillThumbnail(db: PouchDB.Database, doc: Documentish): Promise<void> {
  if (doc._attachments?.["thumbnail"] != null) return;
  const fileInfo = doc._attachments?.["file"];
  if (fileInfo == null) return;
  const ct = fileInfo.content_type ?? "";
  if (!ct.startsWith("image/")) return;

  const blob = await db.getAttachment(doc._id, "file", {rev: doc._rev});
  if (!(blob instanceof Blob)) return;

  const url = URL.createObjectURL(blob);
  try {
    const thumbBlob = await generateThumbnail(url, 200);
    if (thumbBlob == null) return;
    await db.putAttachment(doc._id, "thumbnail", doc._rev, thumbBlob, "image/jpeg");
  } catch (e) {
    if (!isPouchError(e, "conflict")) console.error(e);
  } finally {
    URL.revokeObjectURL(url);
  }
}
